import { ENTRY_POINT } from '@/types/entryPoints';

import { TRACKING_TYPE } from './tracking/constants';

export {
  TRACKING_OPERATION,
  TRACKING_PAGE,
  TRACKING_SECTION,
  TRACKING_TARGET,
  TRACKING_TYPE,
} from './tracking/constants';
import { browserInstance as browser } from './browser';
import { DIALOGUE_TYPE } from '@/types/common';

export { SessionIDType, FAKE_SESSION_ID, isIosReg } from './instantLoaded/constants';

// 默认值

// 固定文案
// title
export const PAGE_HEAD_TITLE = 'page_head_title';

export const INPUT_PLACEHOLDER = 'input_placeholder';

// 欢迎语
export const WELCOME_CONTENT = 'welcome_content';

// HotQuestion 初始化文案
export const HOTQUESTION_INIT_CONTENT = 'hotquestion_init_content';

// 单篇文章的btn文案
export const VIEW_ARTICLE_TEXT = 'view_article_text';

// 加载文案
export const LOADING_TEXT = 'loading_text';

// 选择订单文案
export const SELECT_ORDER_TEXT = 'select_order_text';
export const SELECT_ORDER_CAN_NOT_FIND_TEXT = 'select_order_can_not_find_text';
export const SELECT_RR_REQUEST_TEXT = 'select_rr_request_text_v1';
export const SELECT_RR_TEXT = 'select_rr_text_v1';

// 更多订单文案
export const MORE_ORDER_TEXT = 'more_order_text';
export const MORE_RR_REQUEST_TEXT = 'more_rr_request_text_v1';

export const NO_MORE_BUTTON = 'no_more_button';
export const TO_PAY_TEXT = 'to_pay_text';
export const TO_SHIP_TEXT = 'to_ship_text';
export const TO_RECEIVE_TEXT = 'to_receive_text';
export const COMPLETED_TEXT = 'completed_text';
export const CANCELLED_TEXT = 'cancelled_text';
export const UNPAID_TEXT = 'unpaid_text';
export const SHIPPING_TEXT = 'shipping_text';
export const RETURN_REFUND_TEXT = 'return_refund_text';
export const ALL_TEXT = 'all_text';
export const SELLER_RETURN_REFUND_TEXT = 'seller_return_refund_text';
export const SELLER_CANCELLED_TEXT = 'seller_cancelled_text';

// food buyer 订单panel文案
export const ON_GOING_TEXT = 'shopeefood_onging_text';
export const HISTORY_TEXT = 'shopeefood_history_text';
export const FOOD_BUYER_ORDER_LIST_TITLE_TEXT = 'shopeefood_buyer_order_list_title_text';
export const FOOD_ORDER_TIME_TEXT = 'shopeefood_order_time_text';
export const FOOD_ORDER_CREATED_AT_TEXT = 'shopeefood_order_created_at_time_text';
export const FOOD_ORDER_TODAY_TEXT = 'today_text';

// food buyer 支付方式文案
export const PAY_COD_TEXT = 'pay_cod_text';
export const PAY_SHOPEE_PAY_TEXT = 'shopee_pay_text';
export const PAY_CREDIT_DEBIT_CRAD_TEXT = 'pay_credit_debit_text';
export const PAY_DUITNOW_ONLINE_BANKING_TEXT = 'pay_duitnow_online_banking_text';
export const PAY_ONLINE_BANKING_TEXT = 'pay_online_banking_text';
export const PAY_AIRPAY_GIRO_TEXT = 'pay_airpay_giro_text';
export const PAY_IBANKING_AIRPAY_TEXT = 'pay_iBanking_text';
export const PAY_K_PLUS_TEXT = 'pay_mobile_banking_text';
export const PAY_SHOPEE_PAY_LATER_TEXT = 'pay_spaylater_text';
export const APPLE_PAY_TEXT = 'pay_apple_pay_text';
export const PAY_OTHER_METHOD_TEXT = 'pay_other_method_text';

// food 订单状态文案
export const ORDER_SUBMITTED_TEXT = 'shopeefood_order_submitted_text';
export const ORDER_DRIVER_PICKED_UP_TEXT = 'shopeefood_order_driver_picked_text';
export const ORDER_COMPLETED_TEXT = 'shopeefood_order_completed_text';
export const ORDER_CANCELED_TEXT = 'shopeefood_order_cancelled_text';

// food items/select文案
export const FOOD_TOTAL_TEXT = 'shopeefood_total_text';
export const FOOD_SELECT_ORDER_TEXT = 'shopeefood_select_order';

// 卖家队列应包含文案
export const SELLER_TEXT = 'seller_text';

// 搜索订单
export const SEARCH_ORDER_PLACEHOLDER = 'search_order_placeholder';
export const NO_ORDER_PLACEHOLDER_TEXT = 'no_order_placeholder_text';
export const NO_RESULTS_FOUND = 'not_found_tex';
export const NOT_INPUT_TITLE = 'not_input_title';
export const NOT_INPUT_TEXT = 'not_input_text';
export const SEARCH_ORDER = 'search_order';
export const NO_ORDER_PLACEHOLDER_TEXT_FOR_SHOPEEFOOD = 'no_order_placeholder_text_for_shopeefood';

export const NO_RESULT_FOUND_TEXT = 'no_result_found_text';
export const SEARCH_ORDER_TEXT = 'search_order_text';
export const SEARCH_ORDER_INFO_TEXT = 'search_order_info_text';

// Toal Payment
export const TOTAL_PAYMENT_TEXT = 'total_payment_text';
export const REFUND_AMOUNT_TEXT = 'refund_amount_text';

// Items
export const ITEMS_TEXT = 'items_text';
export const ITEM_TEXT = 'item_text';
export const TOTAL_TEXT = 'total_text';
export const SELECT_TEXT = 'select_text';
export const VIEW_ALL_TEXT = 'view_all_text';
export const VIEW_ALL_ORDERS_TEXT = 'view_all_orders_text';

// 订单载入更多时loading状态
export const ORDER_LOADING_TEXT = 'order_loading_text';

// 订单列表为空
export const NO_ORDERS_YET_TEXT = 'no_orders_yet_text';

// 订单获取失败
export const ORDER_STH_WENT_WRONG_TEXT = 'order_sth_went_wrong_text';

// OrderSN
export const ORDER_SN_TEXT = 'order_sn';

// 下拉订单获取失败
export const LOAD_STH_WENT_WRONG_TEXT = 'load_sth_went_wrong_text';

// 买家订单列表标题
export const BUYER_ORDER_LIST_TITLE_TEXT = 'buyer_order_list_title_text';

// 买家订单列表
export const SELLER_ORDER_LIST_TITLE_TEXT = 'seller_order_list_title_text';

// 登陆成功显示文案
export const LOGIN_SUCCESS = 'login_msg';

// 通话已结束文案
export const YOU_HAVE_ENDED_VIRTUAL_CALL = 'you_have_ended_virtual_call';

export const GROUP_ORDER_TEXT = 'group_order_text';
export const CHECK_ANOTHER_ORDER_TEXT = 'check_another_order_text';
export const CLICK_HERE_TEXT = 'click_here_text';
export const MY_ORDER_TEXT = 'my_order_text';
export const CUSTOMER_HIDDEN_TEXT = 'customer_hidden_text';
export const SELECT_GROUP_ORDER_TEXT = 'select_group_order_text';
export const DELIVERED_TEXT = 'delivered_text';

export const SHIP_BY_DATE = 'ship_by_date';
export const EXPECTED_RECEIVE_TIME = 'expected_receive_time';
export const MSG_MILESTONE_GROUP_READY_FOR_COLLECTION = 'msg_milestone_group_ready_for_collection';
export const DELIVERY_TIME = 'delivery_time';
export const CANCEL_TIME = 'cancel_time';
export const MSG_MILESTONE_GROUP_DELIVERY_UNSUCCESSFUL = 'msg_milestone_group_delivery_unsuccessful';
export const YOU_MAY_WANT_TO_ASK = 'greeting_text_2';
export const DELIVERING_BY = 'delivering_by';
export const ESTIMATED_DELIVERY_ON_BY = 'estimated_delivery_on_by';

export const dirverOrderStatusText = {
  Created: 'created',
  Delivered: 'delivered_text',
  Cancelled: 'cancelled_text',
  Accepted: 'accepted_text',
  Picked: 'picked_text',
  Arrived: 'arrived_text',
  Quit: '',
};

// 跳转salesforce地址
export const LIVE_SALESFORCE_PATH = 'salesforceChat?';
export const LIVE_SALESFORCE_PATH_NEW = 'n/SALESFORCE_CS_CHAT?';
export const SALESFORCE_CS_CHAT_VERSION = 24600;
export const AGENT_CHAT_VERSION = 25300;
// export const FILE_UPLOAD_VERSION = 26700;
export const FILE_UPLOAD_IOS_VERSION = '11.0.0';

// 跳转salesforce，fromPage参数
export const LIVE_FROM_PAGE = 'chatBot';

// 保存history的key值
export const LIVE_SAVE_HISTORY_KEY = 'chatbotHistory';
// 保存history用以恢复的key值
export const LIVE_SAVE_RECOVERY_HISTORY_KEY = 'chatbotHistoryForRecovery';
export const LIVE_CONTEXT_DATA_KEY = 'liveContextData';
export const LIVE_AGENT_DATA_KEY = 'liveAgentData';

// 是否 处于 virtual call 最小化 如果是的话 就使用缓存的消息
export const VIRTUAL_CALL_NEED_RECOVER_HISTORY = 'virtualCallNeedRecoverHistory';
// vc 保存数据的 label
export const SAVE_VIRTUAL_CALL_RECOVERY_CONTEXT = 'save-virtual-call-recovery-context';
// vc 读取数据的 label
export const GET_VIRTUAL_CALL_RECOVERY_CONTEXT = 'get-virtual-call-recovery-context';

// 转人工，提示跳转离线表单相关的key值
// export const LIVE_AGENT_OFFLINE_TEXT = 'live_agent_offline_text'; // 换到config中
export const LIVE_OTHER_ERROR_TEXT = 'live_other_error_text';
export const LIVE_LEAVE_MSG_BTN = 'live_leave_msg_btn';
export const LIVE_OFFLINE_FORM_PAGE = 'live_offline_form_page';
export const LIVE_OFFLINE_FORM_PAGE_FOR_DRIVER = 'live_offline_form_page_for_driver';
export const LIVE_OFFLINE_ERROR_CODE = 60001;
// export const LIVE_DEFAULT_EMERGENCY_TEMPLATE = 'live_default_emergency_template'; // 换到config中

export const MODAL_CLOSE_TEXT = 'modal_close_text';

export const VC_LOW_VERSION_POPUP = 'vc_low_version_popup';
export const VC_LOW_VERSION_UPDATE = 'vc_low_version_update';

// Landing Page UIUX Optimisation (Category and 3x3 HQs) 相关文案
export const HOT_QUESTION_VIEW_MORE_BTN = 'hot_question_view_more_btn';
export const HOT_QUESTION_CHANGE_QUESTIONS_BTN = 'hot_question_change_questions_btn';

// epod 加载失败
export const EPOD_ERROR_MESSAGE = 'epod_error_message';

// 订单 to pay
export const ORDER_TO_PAY_CODE = 1;
// 订单 unpay
export const ORDER_UNPAY_CODE = 1;

/**
 * 从这里拷出来的 '@mkt-common/shopee-common'
 */
const BASE_DOMAIN_ALL = {
  sg: 'shopee.sg',
  my: 'shopee.com.my',
  th: 'shopee.co.th',
  tw: 'shopee.tw',
  vn: 'shopee.vn',
  id: 'shopee.co.id',
  ph: 'shopee.ph',
  br: 'shopee.com.br',
  mx: 'shopee.com.mx',
  co: 'shopee.com.co',
  cl: 'shopee.cl',
  ar: 'shopee.com.ar',
  pl: 'shopee.pl',
  es: 'shopee.es',
  fr: 'shopee.fr',
  in: 'shopee.in',
  xx: 'shopee.systems',
};

function getBaseDomain() {
  const prefix = ENVIRONMENT === 'live' ? '' : (ENVIRONMENT as string) === 'liveish' ? 'live-test.' : `${ENVIRONMENT}.`;
  return `${prefix}${(BASE_DOMAIN_ALL as any)[COUNTRY]}`;
}

const BASE_DOMAIN = getBaseDomain();
/**
 * 从这里拷出来的 '@mkt-common/shopee-common'
 */

const URL_PREFIX = `https://${BASE_DOMAIN}`;

// 重定向URL列表
export const REDIRECTION_URLS = {
  driver_order_on_going_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fORDER_ONGOING?serviceType=${service_type}&driverDeliveryOrderId=${driver_delivery_id}',
    type: 'h5',
  },
  driver_order_details_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fORDER_ONGOING_DETAIL?serviceType=${service_type}&orderId=${order_id_string}&deliveryId=${delivery_id}&storeId=${store_id}',
    type: 'h5',
  },
  driver_order_history_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fORDER_HISTORY',
    type: 'h5',
  },
  driver_incentive_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fINCENTIVES',
    type: 'h5',
  },
  driver_report_issue_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fREPORT_ISSUE_FOR_FOOD_CANCEL?serviceType=${service_type}&orderId=${order_id_string}',
    type: 'h5',
  },
  driver_hub_performance_page: {
    url: 'foody://driver/rn/%40shopee-rn%2Fmain%2FTRANSITION?page=HUB_PERFORMANCE',
    type: 'h5',
  },
  driver_hub_schedule_page: {
    url: 'foody://driver/rn/%40shopee-rn%2Fmain%2FTRANSITION?page=HUB_SCHEDULE',
    type: 'h5',
  },
  driver_my_hub_page: {
    url: 'foody://driver/rn/%40shopee-rn%2Fmain%2FTRANSITION?page=ID_MY_HUB',
    type: 'h5',
  },
  driver_hub_page: {
    url: 'foody://driver/rn/%40shopee-rn%2Fmain%2FTRANSITION?page=ID_HUB',
    type: 'h5',
  },
  driver_qms_page: {
    url: 'foody://driver/rn/%40shopee-rn%2Fmain%2FQMS_HOME',
    type: 'h5',
  },
  spx_ongoing_order_page: {
    url: 'foody://driver/rn/%40shopee-rn%2Fmain%2FORDER_ONGOING?serviceType=${service_type}&driverDeliveryOrderId=${driver_delivery_id}',
    type: 'h5',
  },
  spx_order_ongoing_detail_page: {
    url: 'foody://driver/rn/%40shopee-rn%2Fmain%2FORDER_ONGOING_DETAIL?serviceType=${service_type}&orderId=${order_id_string}&deliveryId=${delivery_id}&storeId=${store_id}',
    type: 'h5',
  },
  spx_report_issue_rejection_page: {
    url: 'foody://driver/rn/%40shopee-rn%2Fmain%2FREPORT_ISSUE_FOR_SPX_CANCEL?serviceType=${service_type}&orderId=${order_id_string}',
    type: 'h5',
  },
  vn_driver_ongoing_order_details_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fREBORN_ORDER_DETAIL?code=${driver_order_code}&type=${driver_order_type}',
    type: 'h5',
  },
  vn_driver_complete_order_details_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fREBORN_ORDER_DETAIL?code=${driver_order_code}&type=${driver_order_type}',
    type: 'h5',
  },
  vn_driver_order_deny_reason_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fORDER_DENY_REASON?code=${driver_order_code}&type=${driver_order_type}',
    type: 'h5',
  },
  vn_driver_order_report_reason_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fORDER_REPORT_REASON?code=${driver_order_code}&type=${driver_order_type}',
    type: 'h5',
  },
  vn_driver_order_quit_reason_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fORDER_QUIT_REASON?code=${driver_order_code}&type=${driver_order_type}',
    type: 'h5',
  },
  vn_driver_order_return_to_sender_reason_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fORDER_RETURN_TO_SENDER_REASON?code=${driver_order_code}&type=${driver_order_type}',
    type: 'h5',
  },
  vn_driver_order_return_to_company_reason_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fORDER_RETURN_TO_COMPANY_REASON?code=${driver_order_code}&type=${driver_order_type}',
    type: 'h5',
  },
  vn_driver_my_profile_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fREBORN_PROFILE',
    type: 'h5',
  },
  vn_driver_contact_information_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fCONTACT_INFORMATION',
    type: 'h5',
  },
  vn_driver_my_service_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fMY_SERVICE',
    type: 'h5',
  },
  vn_driver_contract_list_page: {
    url: 'foody://driver/n/user/contracts',
    type: 'h5',
  },
  vn_driver_tax_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fREBORN_TAX',
    type: 'h5',
  },
  vn_driver_order_assignment_page: {
    url: 'foody://driver/rn/%40shopee-rn%2fmain%2fORDER_ASSIGNMENT',
    type: 'h5',
  },
  vn_driver_language_page: {
    url: 'foody://driver/n/driver/language',
    type: 'h5',
  },
  vn_driver_notification_settings_page: {
    url: 'foody://driver/n/driver/notification_settings',
    type: 'h5',
  },
  vn_driver_my_account_page: {
    url: 'foody://driver/n/driver/tob_account',
    type: 'h5',
  },
  order_detail_page: {
    module: '@shopee-rn/order-processing/ORDER_DETAIL?orderID=${orderId}',
    type: 'rn',
  },
  order_detail_page_seller: {
    module: '@shopee-rn/seller-order/ORDERDETAIL',
    type: 'rn',
  },
  topay_order_detail_page: {
    module: '@shopee-rn/order-processing/ORDER_DETAIL?checkoutId=${checkoutId}',
    type: 'rn',
  },
  topay_order_detail_page_seller: {
    module: '@shopee-rn/seller-order/ORDERDETAIL',
    type: 'rn',
  },
  shopeefood_order_detail_page_buyer: {
    module: '@shopee-rn/now-food/ORDER_DETAILS',
    type: 'rn',
  },
  buyer_order_return_page: {
    url: URL_PREFIX + '/buyer/return/view/${return_id}',
    type: 'h5',
  },
  seller_order_return_page: {
    url: URL_PREFIX + '/buyer/return/seller/view/${return_id}',
    type: 'h5',
  },
  shipping_info_page: {
    module: '@shopee-rn/order-processing/SHIPPING_INFO?orderId=${order_id}',
    type: 'rn',
  },
  request_order_return_page: {
    url: URL_PREFIX + '/buyer/return/add/shopid/${shop_id}/orderid/${order_id}/',
    type: 'h5',
  },
  shopee_pay_page: {
    url: URL_PREFIX + '/wallet/setup',
    type: 'h5',
  },
  reset_pin_page: {
    url: URL_PREFIX + '/wallet/changepin',
    type: 'h5',
  },
  my_voucher_page: {
    module: 'VOUCHER_WALLET_HOME_PAGE',
    type: 'rn',
  },
  // btnClickHandler直接给URL，此处作废
  /*
  live_offline_form_page: {
    url: LIVE_OFFLINE_FORM_URL[COUNTRY],
    type: 'h5',
  },
  */
  live_chat_feedback_dialog: {
    params: { module: 'LIVE_CHAT_FEEDBACK_DIALOG' },
    type: 'rn-sf',
  },
  contact_seller_page: {
    params: { module: 'CHAT?userID.i=${user_id}' },
    type: 'n',
  },
  tfe_contact_seller_page: {
    params: { module: 'CHAT?userID.i=${seller_user_id}' },
    type: 'n',
  },
  tfe_contact_buyer_page: {
    params: { module: 'CHAT?userID.i=${user_id}' },
    type: 'n',
  },
  drc_discuss_page: {
    url: `https://drc-h5.${BASE_DOMAIN}/` + '${return_id}',
    type: 'h5',
  },
  drc_discuss_two_way_page: {
    url: `https://drc-h5.${BASE_DOMAIN}/` + '${return_id}' + '?room_type=2',
    type: 'h5',
  },
  change_mobile_number_page: {
    module: 'ACCOUNT_PHONE',
    type: 'rn',
  },
  shopee_pay_wallet_page: {
    module: 'WALLET',
    type: 'rn',
  },
  upload_evidence_page: {
    module: '@shopee-rn/case-dispute/UPLOAD_EVIDENCE',
    type: 'rn',
    paramsGenerator: (uri_extra: Record<string, string | number>) => ({
      returnId: uri_extra.return_id,
      returnSn: uri_extra.return_sn,
    }),
  },
  return_refund_detail_page: {
    module: '@shopee-rn/seller-return/DETAIL',
    type: 'rn',
    paramsGenerator: (uri_extra: Record<string, string | number>) => ({ returnId: uri_extra.return_id }),
  },
  linked_payment_methods_page: {
    module: '@shopee-rn/shopeepay/BANK_ACCOUNTS_AND_CARDS_HOME?pageType=marketPlace',
    type: 'rn',
  },
  order_list_page: {
    module: '@shopee-rn/order-processing/ORDER_LIST_BUYER',
    type: 'rn',
  },
  case_tracker_detail_page: {
    url:
      `https://help.${BASE_DOMAIN}/universal-link/portal/mysupportcase/detail`
      + '?caseid=${case_id}&source=4&deep_and_deferred=1',
    type: 'h5',
  },
  virtual_call_page: {
    module:
      `@shopee-rn/virtualcall-plugin/CALL?businessType=1&domain=help.${BASE_DOMAIN}&entryPoint=`
      + '${entryPoint}&businessId=${businessId}&userType=${userType}&enquiryType=${enquiryType}&orderSn=${orderSn}&reasonCode=${reasonCode}&userTypeLabel=${userTypeLabel}',
    type: 'rn',
  },
  shopee_user_bank_account_list_page: {
    module: '@shopee-rn/shopeepay/BANK_ACCOUNTS_AND_CARDS_HOME?pageType=marketPlace',
    type: 'rn',
  },
  food_order_page: {
    module: '${rnLink}',
    type: 'rn',
  },
  bank_app_store_page: { type: 'app-store' },
};

export const TRANSIFY_KEY = {
  MSG_ERROR_TO_LIVE: 'msg_error_to_live',
  MSG_TO_LIVE: 'msg_live',
  PREMIUM_MSG_TO_LIVE: 'premium_msg_live',
  PREMIUM_GREETING_TO_LIVE: 'premium_greeting_to_live',
  BTN_LIVE: 'btn_live',
  LIVECHAT_CHAT_WITH_AGENT_MESSAGE: 'livechat_chat_with_agent_message',
  SHOPEE_FOOD_DEFAULT_GREETING: 'shopee_food_default_greeting',
  AGENT_QUEUE_CANCEL_THANKS: 'agent_queue_cancel_thanks',
  AGENT_QUEUE_CANCEL_THANKS_INAGENT: 'agent_queue_cancel_thanks_inagent',
  QUEUE_FILTER_MESSAGE: 'queue_filter_message',
  QUEUE_FILTER_SELECT_YES: 'queue_filter_select_yes',
  QUEUE_FILTER_SELECT_NO: 'queue_filter_select_no',
  MESSAGE_LIVEAGENT_CHATWITHAGENT: 'message_liveagent_chatwithagent',
  MESSAGE_LIVEAGENT_SEND_INQUIRY_TIP: 'message_liveagent_send_inquiry_tip',
};

// 需要多上报一次 STANDARDIZE_BUTTON 的 tracking
export const NEED_REPORT_STANDARDIZE_BUTTON = [TRACKING_TYPE.BUTTON];

export enum HIPO_TYPE {
  ACTION_PAGE_PV = 'action_page_pv',
  ACTION_PAGE_PERFORMANCE = 'action_page_performance',
  ACTION_JS_ERROR = 'action_js_error',
  ACTION_API_REQUEST = 'action_api_request',
}

export const SUCCESS_CODE = 0;

export const PRE_CHAT_ENTITIES = [
  {
    saveToTranscript: 'Case',
    linkToEntityName: null,
    showOnCreate: true,
    linkToEntityField: null,
    entityName: 'Case',
    entityFieldsMaps: [
      {
        isExactMatch: false,
        label: 'Requestor Name',
        doFind: false,
        fieldName: 'Shopee_ID_Requestor_Name__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Requestor Phone',
        doFind: false,
        fieldName: 'Shopee_ID_Requestor_Phone__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Requestor Email',
        doFind: false,
        fieldName: 'Shopee_ID_Requestor_Email__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'User Name',
        doFind: false,
        fieldName: 'Shopee_ID_User_Name__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'User ID',
        doFind: false,
        fieldName: 'Shopee_ID_User_Id__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Subject',
        doFind: false,
        fieldName: 'Subject',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Case Country',
        doFind: false,
        fieldName: 'Shopee_ID_Case_Country__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Contact Type',
        doFind: false,
        fieldName: 'Origin',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Shopee Chat Key',
        doFind: false,
        fieldName: 'Shopee_Chat_Key__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Shopee App Version',
        doFind: false,
        fieldName: 'Shopee_App_Version__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Last Article URL',
        doFind: false,
        fieldName: 'Shopee_ID_Last_Article_URL__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Chatbot article',
        doFind: false,
        fieldName: 'Shopee_Chatbot_Article__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Chatbot taskbot',
        doFind: false,
        fieldName: 'Shopee_Chatbot_Taskbot__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Chatbot history',
        doFind: false,
        fieldName: 'Shopee_Chatbot_History__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Shopee_Chatbot_Session_Id',
        doFind: false,
        fieldName: 'Shopee_Chatbot_Session_Id__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Order SN',
        doFind: false,
        fieldName: 'Shopee_ID_Order_ID__c',
        doCreate: true,
      },
      // {
      //   'isExactMatch': false,
      //   'label': 'Customer Loyalty Tier',
      //   'doFind': false,
      //   'fieldName': 'Customer_Loyalty_Tier__c',
      //   'doCreate': true
      // },
      {
        isExactMatch: false,
        label: 'Customer Loyalty Tier Code',
        doFind: false,
        fieldName: 'Customer_Loyalty_Tier_Code__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'User Type',
        doFind: false,
        fieldName: 'Shopee_ID_Seller_Buyer__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Enquiry Type',
        doFind: false,
        fieldName: 'Shopee_ID_Enquiry_Type__c',
        doCreate: true,
      },
      {
        isExactMatch: false,
        label: 'Entry Point',
        doFind: false,
        fieldName: 'Chat_Category__c',
        doCreate: true,
      },
    ],
  },
];

export enum Transaction {
  more = 'label_more_transaction_btn',
  select = 'label_select_transaction_btn',
  labelWithdrawalPrefix = 'label_withdrawal_prefix',
  labelTopupPrefix = 'label_topup_prefix',
  labelWithdrawal = 'label_withdrawal',
  labelTopup = 'label_topup',
}

// export enum SessionIDType {
//   CHAT_BOT = 'chatbot',
//   AGENT = 'agent',
// }

export const GetMsgResCode = {
  SUCCESS: 0,
  TIMEOUT: 204, // 超时
  BAD_REQ: 400,
  ILLEGAL: 403, // agent: 不合法，终止; chatbot: v1.1.2 noLogin 后理论上不会触发，跳转登录通过reply_type = 9标识
  CONFLICT: 409, // 多个轮询冲突
  TOO_FREQUENT: 429,
  NOT_LOGIN: 1003,
  SESSION_ID_MISSING: 1004,
  MULTI_TERMINAL_CONFLICT: 1020, // 多端冲突
  TEMPORARY_ERROR: 40000, // 临时错误，重试2次
  SESSION_EXPIRED: 40001, // session已过期
  SESSION_ID_WRONG: 40006,
  CANCEL_ORDER_FAILED: 40008,
  LIVE_OFFLINE_ERROR_CODE: 60001,
  ARTICLE_IS_DELETED: 40010, // 文章被删除
  SEND_FAIL: 60002, // 发送失败，重试2次
  UNEXPECTED_CHAT_END: 2001,
  LIVE_CHAT: 1026, // LiveChatSDK 初始化

  TIMEOUT_ERROR: 'TIMEOUT',
  NETWORK_ERROR: 'NETWORK_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
};

export const ChatMsgType = {
  CHAT_TRANSFER: 'CHAT_TRANSFER', // SF chat case transfer
  CHAT_REQUEST_FAIL: 'ChatRequestFail',
  AGENT_DISCONNECT: 'AgentDisconnect',
};

export const Copywriting = {
  AGENT_ENTER_TIPS: 'agent_enter_tips',
  AGENT_LEAVE_TIPS: 'agent_leave_tips',
  USER_LEAVE_TIPS: 'user_leave_tips',
  CHAT_TRANSFER: 'agent_reassign_tips',
  QUEUE_TIPS: 'queue_tips',
  AGENT_QUEUE_LONG_TIPS: 'agent_queue_long_tips',
  AGENT_QUEUE_TIPS: 'agent_queue_tips',
  AGENT_QUEUE_CANCEL_BTN: 'agent_queue_cancel_btn',
  AGENT_QUEUE_EMAIL_BTN: 'agent_queue_email_btn',
  AGENT_QUEUE_CANCEL_CONFIRM: 'agent_queue_cancel_confirm',
  AGENT_QUEUE_EMAIL_CONFIRM: 'agent_queue_email_confirm',
  AGENT_QUEUE_LONG_TIME: 'agent_queue_long_time',
  AGENT_QUEUE_LONG_TIME_WITH_CANCEL: 'agent_queue_long_time_with_cancel',
  AGENT_QUEUE_LONG_TIME_WITH_CANCEL_EMAIL: 'agent_queue_long_time_with_cancel_email',
  CHAT_BOT_CLOSE_TIP_CONTENT: 'chat_bot_close_tip_content',
  AGENT_ENTERING_TIPS: 'agent_entering_tips',
  TYPING_CONTENT: 'typing_content',
  LOADING_IN_AGENT_TEXT: 'loading_in_agent_text',
  SESSION_END: 'session_end',
  AGENT_SESSION_TIMEOUT: 'agent_session_timeout',
  AGENT_SESSION_ERROR: 'agent_session_error',
  AGENT_TRANSFER_SESSION: 'agent_transfer_session',
  TRANSFER_NEW_AGENT_INCOMING: 'transfer_new_agent_incoming',
  UNREAD_MSG: 'unread_msg_text',
  UNREAD_MSGS: 'unread_msgs_text',
  IMAGE_UPLOAD_OVERSIZE: 'image_upload_oversize',
  FILE_UPLOAD_OVERSIZE: 'file_upload_oversize',
  FILE_PREVIEW_IN_OLD_VERSION: 'file_preview_in_old_version',
  POPUP_WHEN_UPLOADING: 'popup_when_uploading',
  FILE_TYPE_UNSUPPORTED: 'file_type_unsupported',
  MODAL_CANCEL_TEXT: 'modal_cancel_text',
  MODAL_OK_TEXT: 'modal_ok_text',
  FACIAL_VERIFICATION_TIP: 'chat_fv_request',
  FACIAL_VERIFICATION_BUTTON: 'chat_fv_button',
  FACIAL_VERIFICATION_START_TIP: 'chat_fv_start',
  FACIAL_VERIFICATION_UPDATE_VERSION_TIP: 'chat_fv_update_version',
  FACIAL_VERIFICATION_UPDATE_VERSION_LINK: 'chat_fv_update_now',
  FACIAL_VERIFICATION_HELP_CENTER_LINK: 'chat_fv_help_center',
  FACIAL_VERIFICATION_SUCCESS_TIP: 'chat_fv_submit_system',
  FACIAL_VERIFICATION_FAILED_TIP: 'chat_fv_unable_submit',
  FACIAL_VERIFICATION_ERROR_TIP: 'chat_fv_error_pop_up',
  UPDATE_VERSION_MODAL_TITLE: 'chat_fv_update_pop_tittle',
  UPDATE_VERSION_MODAL_TIP: 'chat_fv_update_pop_content',
  UPDATE_VERSION_MODAL_LATER_BUTTON: 'chat_fv_update_pop_later',
  UPDATE_VERSION_MODAL_UPDATE_BUTTON: 'chat_fv_update_pop_update_now',
};

export const HISTORY_TRANSIFY_KEY = {
  NO_MORE_HISTORY: 'no_more_history',
  NO_MORE_HISTORY_IN_X_DAYS: 'no_more_history_in_x_days',
  UNSUPPORTED_MESSAGE: 'unsupported_message',
  FAIL_TO_LOAD_IMAGE: 'fail_to_load_image',
  RELOAD: 'reload',
  FILE_IS_INVALID: 'file_is_invalid',
  ARTICLE_HAS_BEEN_DELETED: 'article_has_been_deleted',
  FAIL_TO_LOAD_FILE: 'fail_to_load_file',
  MODAL_TITLE_NOTICE: 'modal_title_notice',
  MODAL_OK_TEXT: 'modal_ok_text',
  MULTI_TERMINAL_CONFLICT: 'multi_terminal_conflict',
  USER_CLOSE_SESSION: 'user_close_session',

  UNREAD_MESSAGE_IMAGE: 'unread_message_image',
  UNREAD_MESSAGE_FILE: 'unread_message_file',
  UNREAD_MESSAGE_ORDER: 'unread_message_order',
  UNREAD_MESSAGE_CREDIT_CARD: 'unread_message_credit_card',
  UNREAD_MESSAGE_DEFAULT: 'unread_message_default',

  HISTORY_BUTTON_DISABLED: 'history_button_disabled',
};

// TimeOut
export const extraTime = 5; // 5s
export const initTimeOut = 60 * 1000; // 60s

export const AGENT_END_REASON = {
  NOT_END: 0,
  NORMAL: 1,
  OTHER: 2,
  TIMEOUT: 3,
  USER_CANCEL_QUEUE: 4, // 用户在H5页面，排队过程中，结束live agent
};

// Version
export const isAndroidReg = /Android/i;
export const getIosVersionReg = /OS [0-9_]*/;
export const getAndroidVersionReg = /Android [0-9\.]*/;
export const addPointToVersionReg = /(?=(\B)(\d{2})+$)/g;
export const IOS_IN_USE_AGENT = 'OS';
export const IOS = 'iOS';
export const VERSION_CONNECT = '.';

export const isApp = browser.shopeeAppOrLiveChat;

export const FIRE_FLAG = {
  NOT_REQUEST: 0,
  IS_REQUESTING: 1,
  FINISH: 2,
};

export const INPUT_TYPE = {
  TYPING: 0,
  BUTTON: 1,
  INPUT_BY_SUGGESTION: 4,
  INPUT_BY_CLICK_ORDER: 12,
  INPUT_BY_CLICK_ORDER_SHORTCUT: 13,
  INPUT_BY_CLICK_ORDER_CONFIRMATION_NO: 14,
  INPUT_BY_CLOSE_VIRTUAL_CALL: 15,
  INPUT_BY_CLICK_OTHER_FREQUENTLY_ASKED: 16,
};

// v2.5 cancel order
export const CANCEL_ORDER_BTN_CANCEL_TEXT = 'popup_window_not_now';
export const CANCEL_ORDER_BTN_CONFIRM_TEXT = 'popup_window_confirm';
export const CANCEL_ORDER_REASON_TITLE_TEXT = 'choose_cancel_reason_title';

export const CANCEL_ORDER_STEP = {
  CHOOSE_REASON: 1,
  CONFIRMATION: 2,
};

export const ENQUIRY_DETAILS_STEP = {
  CHOOSE_CATEGORY: 1,
  CHOOSE_OPTION: 2,
};

// v3.0 RR Taskbot
export const ORDER_SHOW_TYPE = {
  ORDER_BOT: 1,
  RR_BOT: 2,
};

export enum FROM {
  ShopeeFoodHC = 'shopeeFoodHC',
  Mitra = 'mitra',
  MitraPartner = 'MitraPartner',
  ShopeeFoodPartner = 'ShopeeFoodPartner',
  ShopeePayPartner = 'ShopeePayPartner',
  MystockPartner = 'MystockPartner',
}

// v3.2 Feedback NegativeOptions
export const NEGATIVE_OPTION_TYPE = {
  CLICK: 1,
  FREETEXT: 2,
};

export const BUTTON_TYPE = {
  PRIMARY: 1,
  PRIMARY_DISABLED: 2,
  PRIMARY_OUTLINED: 3,
  SECONDARY: 4,
  SECONDARY_DISABLED: 5,
  FRAMELESS: 6,
  FRAMELESS_DISABLED: 7,
  TRADITIONAL: 8,
  TRADITIONAL_DISABLED: 9,
  ORDINARY_SELECTOR: 10,
};

export const originHeight = (document.documentElement || document.body)?.clientHeight;

// 多条消息延迟发送间隔ms
export const SEND_MESSAGE_DELAY = 200;

// 非WIFI环境，文件达到上限时提示 byte
export const NONE_WIFI_MAX_FILE_SIZE = 10 * 1024 * 1024;

// 非WIFI上传确认按钮
export const NONE_WIFI_UPLOAD_CONFIRM = 'modal_confirm_text';

// 非WIFI上传取消按钮
export const NONE_WIFI_UPLOAD_CANCEL = 'modal_cancel_text';

// entry point 枚举 进入chatbot时，url上的from参数值
export enum ENTRY_POINT_IN_URL {
  general,
  mePage,
  sellingPage,
  shippingPage,
  helpCentre,

  // premium user
  mePagePremium = 100,
  helpCentrePremium = 101,
}

/* 平台默认队列 */
export enum DefaultQueueName {
  ShopeeFood = 'TH Chat-Buyer-Food Delivery',
}

// 最长获取历史消息天数
export const MAX_SHOW_HISTORY_DAYS = 180;

// 加载历史消息的下拉高度
export const HISTORY_LOADING_HEIGHT = 40;

// 历史消息显示时间间隔 (minute)
export const HISTORY_SHOW_TIME_MINUTES = 5;

// 一次获取历史消息条数
export const GET_HISTORY_MESSAGE_COUNT = 20;

// 上报使用 区分是否历史消息
export enum TRACKING_MSG_TYPE {
  HISTORY = 1,
  REAL_TIME = 0,
}

// 上报使用 区分是或否
export enum TRACKING_BOOLEAN {
  Yes = 1,
  No = 0,
}

// 上传消息给后端 用来记录历史消息的时间间隔
export const UPLOAD_MESSAGE_TO_SAVE_TIME = 300;

export const PREMIUM_USER_TRANSIFY_KEY = {
  PREMIUM_AGENT_TITLE: 'premium_agent_title',
  PREMIUM_USER_CONNECTING: 'premium_user_connecting',
  PREMIUM_USER_QUEUE_NUMBER: 'premium_user_queue_number',
  PREMIUM_USER_WAIT_FOR_AGENT: 'premium_user_wait_for_agent',
  CANCEL: 'modal_cancel_text',
};

// 1s内只允许获取一次intent列表
export const LOCK_INTENT_NEXT_PAGE_TIME = 1000;

// intent hot question 点击下一页
// 2s后再展示loading
export const SHOW_INTENT_HOT_QUESTION_LOADING_TIME = 2000;

export const FAIL_TO_LOAD_QUESTIONS = 'fail_to_load_questions';

export const ReportLabel = {
  Agent: { start: 'agent_start' },
  AgentError: {
    default: 'agent_error_total',
    WaitingTooLong: 'agent_error_wait_more_than_5s',
    Offline: 'agent_error_agent_offline_total',
    MultiTerminalConflict: 'agent_error_multi_terminal_conflict_total',
    BeforeAgentEstablish: 'agent_error_before_agent_establish_total',
    NetworkError: 'agent_error_network_error_total',
    DataError: 'agent_error_data_error_total',
  },
  Video: {
    VideoUploadSucceed: 'video_upload_succeed',
    VideoFailedByGetTokenFailed: 'video_upload_failed_by_get_token_failed',
    VideoFailedByCompressFailed: 'video_upload_failed_by_compress_failed',
    VideoFailedByUploadFailed: 'video_upload_failed_by_upload_failed',
    VideoFailedBySendMessageFailed: 'video_upload_failed_by_send_message_failed',
    VideoFailedBySessionEnd: 'video_upload_failed_by_session_end',
  },
};

export const ORDER_ID_TRANSIFY_KEY = 'order_id';

export const PicAndVideoLimit = {
  Count: 9,
  VideoMaxSize: 30, // MB
  VideoMinDuration: 1, // s
  VideoMaxDuration: 180, // s
  PicSize: 2, // MB
  VideoCoverMaxWidthOrHeight: 300,
  VideoCoverCompressionQuality: 80,
};

export const MediaSourceType = {
  AlbumAndCamera: 0,
  Camera: 1,
  Album: 2,
};

export const MediaType = {
  ImageAndVideo: 0,
  Image: 1,
  Video: 2,
};

export const MediaConstants = {
  UploadBizId: '123',
  MediaBizId: 1005,
};

export const VideoTransifyKey = {
  VideoStatusUploading: 'video_status_uploading',
  VideoStatusFailed: 'video_status_failed',
  VideoUploadingFailed: 'video_uploading_failed',
  VideoUploadingPrompt: 'video_uploading_prompt',
};

// 5s 之内只弹出一次提示
export const ToastMediaErrorTime = 5 * 1000;

// 使用 media sdk 和 upload sdk 的最低版本
// export const NEW_MEDIA_UPLOAD_VERSION = 27300;
// 部分地区不使用默认 media upload 版本
// 需要使用 地区-系统 区分
// export const NEW_MEDIA_COUNTRY_VERSION_MAP = new Map([
//   ['co-android', 27700],
//   ['co-ios', 27434],
//   ['cl-android', 27700],
//   ['cl-ios', 27434],
// ]);

// export const DEFAULT_NEW_MEDIA_UPLOAD_VERSION = 27300;

// 映射真实的入口
// 在 api/init_session 时使用
export const ACTUAL_ENTRY_POINT = {
  [ENTRY_POINT.mePagePremium]: ENTRY_POINT.mePage,
  [ENTRY_POINT.helpCentrePremium]: ENTRY_POINT.helpCentre,
  [ENTRY_POINT.RRDetailsPagePremium]: ENTRY_POINT.RRDetailsPage,
  [ENTRY_POINT.RRShippingPagePremium]: ENTRY_POINT.RRShippingPage,
};

// 铂金用户的entry point
export const PREMIUM_USER_ENTRY_POINT = [
  ENTRY_POINT.mePagePremium,
  ENTRY_POINT.helpCentrePremium,
  ENTRY_POINT.RRDetailsPagePremium,
  ENTRY_POINT.RRShippingPagePremium,
];

// 用户是点击哪种button进入的chatbot
export enum ENTRY_BUTTON_TYPE {
  NORMAL_BUTTON = 1,
  PREMIUM_BUTTON,
}

// chatbot type
export enum CHATBOT_TYPE {
  /** 普通用户 走chatbot */
  NORMAL_CHATBOT = 1,
  /** 高级用户 走chatbot */
  PREMIUM_CHATBOT,
  /** 高级用户 走live chat */
  PREMIUM_LIVE_CHAT,
}

// 用户是否点击live agent shortcut
export enum SHORTCUT_RESPONSE_TYPE {
  NOT_LIVE_AGENT,
  IS_LIVE_AGENT,
}

// app type
export enum APP_BOT_TYPE {
  GENERAL = 0,
  BUYER_BOT = 1,
  SELLER_BOT = 2,
  SOLUTION_BASE_BOT = 3,
  INTENT_BASE_BOT = 4,
  DRIVER_BOT = 5,
}

export enum ALL_BOT_TYPE {
  UN_KNOWN_BOT = 0,
  INTENT_BASE_BOT = 1,
  SELLER_BASE_BOT = 2,
  SHOPEE_FOOD_BOT = 3,
}

// 上报客服消息延时
export const ReportAgentMessageTimeout = 500;

export enum SourceInUrl {
  PUSH_NOTIFICATION = 'push_notification',
}

// 获取未读消息数量限制
export const GetUnreadMsgLimit = 30;

export enum IS_GREATER_THAN_THRESHOLD {
  NO,
  YES,
}

export const LIVE_CHAT_SDK_TOKEN_KEY = 'live_chat_sdk_token';

export const IntentSource = {
  ThreeMultiThree: 1,
  Shortcuts: 2,
  Category: 3,
  FAQ: 4,
  KB: 5,
  LiveAgent: 6,
  RedirectionButton: 7,
  RelatedIntent: 10,
};

export const ClientType = {
  App: 1,
  Web: 2,
};

export enum TFEOrderUserType {
  Buyer = 1,
  Seller,
}

export const TFE_ORDER_TABS_SELLER_OFFSET = 5;

// hard code 跟BE status_text中的All对应的value值相关
export const TFE_ORDER_VALUE_OF_TABALL = 0;

// hard code 跟BE status_text中的Return对应的value值相关
export const TFE_ORDER_VALUE_OF_TABRETURN = 11;

// TFE ORDER订单状态
export const ORDER_ALL = 0;
export const BUYER_TO_PAY = 1;
export const BUYER_TO_SHIP = 2;
export const BUYER_TO_RECEIVE = 3;
export const BUYER_COMPLETE = 4;
export const BUYER_CANCELLED = 5;
export const SELLER_UNPAID = 6;
export const SELLER_TO_SHIP = 7;
export const SELLER_SHIPPED = 8;
export const SELLER_COMPLETE = 9;
export const SELLER_CANCELLED = 10;
export const ORDER_RETURN = 11;

export const BUYER_TABS = [
  ORDER_ALL,
  BUYER_TO_PAY,
  BUYER_TO_SHIP,
  BUYER_TO_RECEIVE,
  BUYER_COMPLETE,
  BUYER_CANCELLED,
  ORDER_RETURN,
];
export const SELLER_TABS = [
  ORDER_ALL,
  SELLER_UNPAID,
  SELLER_TO_SHIP,
  SELLER_SHIPPED,
  SELLER_COMPLETE,
  SELLER_CANCELLED,
  ORDER_RETURN,
];

// 点击select 按钮
export const ReportSelectButtonId = 'btn_0';
export const ReportSelectButtonType = 'btn_list';
// 点击more按钮
export const ReportSelectMoreButtonId = 'btn_1';
export const ReportSelectMoreButtonType = 'btn_more';
// panel中点击按钮
export const ReportListButtonType = 'btn_more_list';
export const ReportListButtonId = 'btn_2';
// panel 中 still not found
export const ReportStillNotFoundButtonType = 'btn_live';
export const ReportStillNotFoundButtonId = 'btn_3';

export const BANK_POLICY_CONTENT = 'bank_policy_content';

export const ONE_HOUR = 3600 * 1000;

export enum REDIRECTION_BUTTON_TRIGGER_TYPE {
  URL = 'URL',
  TASK_BOT = 'TASK_BOT',
  INTENT = 'INTENT',
  FORM = 'FORM',
}

// Partner App 下各个业务线新增的Transify Keys
export const PARTNER_APP_BUSINESS_TRANSIFY_KEYS = {
  MitraPartner: {
    greeting: 'mitra_partner_greeting',
    chatWithAgent: 'mitra_partner_chat_button',
    noAgent: 'mitra_partner_no_agent',
    emergency: 'mitra_partner_emergency',
  },
  ShopeeFoodPartner: {
    greeting: 'shopeefood_partner_greeting',
    chatWithAgent: 'shopeefood_partner_chat_button',
    noAgent: 'shopeefood_partner_no_agent',
    emergency: 'shopeefood_partner_emergency',
  },
  ShopeePayPartner: {
    greeting: 'shopeepay_partner_greeting',
    chatWithAgent: 'shopeepay_partner_chat_button',
    noAgent: 'shopeepay_partner_no_agent',
    emergency: 'shopeepay_partner_emergency',
  },
  MystockPartner: {
    greeting: 'mystock_partner_greeting',
    chatWithAgent: 'mystock_partner_chat_button',
    noAgent: 'mystock_partner_no_agent',
    emergency: 'mystock_partner_emergency',
  },
};

export enum AccountType {
  MitraPartner = 25,
  ShopeeFoodPartner = 22,
  ShopeePayPartner = 23,
  MystockPartner = 24,
  BankIDMePage = 11,
  BankIDHelpCenter = 11,
  BankSGMePage = 11,
  BankSGHelpCenter = 11,
}

export enum IntentType {
  HeadIntent = 1,
  ShortcutIntent = 3,
}

export enum OrderCardType {
  oldCarousel = 0,
  newCarousel,
  bigCarousel,
  verticalList,
  twoRowCarousel,
  orderWithCopy,
  smallOrder,
}

export enum LiveAgentControl {
  remain = 0,
  hide = 1,
  show = 2,
}

export enum ChatbotComponentType {
  OldChatbot = 0,
  ChatbotUI = 1,
}

export const PAY_METHOD_MAP = {
  1: PAY_COD_TEXT,
  2: PAY_SHOPEE_PAY_TEXT,
  7: PAY_CREDIT_DEBIT_CRAD_TEXT,
  8: PAY_DUITNOW_ONLINE_BANKING_TEXT,
  9: PAY_ONLINE_BANKING_TEXT,
  11: PAY_CREDIT_DEBIT_CRAD_TEXT,
  12: PAY_SHOPEE_PAY_TEXT,
  13: PAY_AIRPAY_GIRO_TEXT,
  14: PAY_IBANKING_AIRPAY_TEXT,
  15: PAY_K_PLUS_TEXT,
  20: PAY_SHOPEE_PAY_TEXT,
  21: APPLE_PAY_TEXT,
};

export const FOOD_METHOD_MAP = {
  0: ORDER_SUBMITTED_TEXT,
  100: ORDER_SUBMITTED_TEXT,
  200: ORDER_SUBMITTED_TEXT,
  300: ORDER_SUBMITTED_TEXT,
  400: ORDER_SUBMITTED_TEXT,
  410: ORDER_SUBMITTED_TEXT,
  420: ORDER_SUBMITTED_TEXT,
  425: ORDER_SUBMITTED_TEXT,
  430: ORDER_DRIVER_PICKED_UP_TEXT,
  440: ORDER_COMPLETED_TEXT,
  800: ORDER_COMPLETED_TEXT,
  900: ORDER_SUBMITTED_TEXT,
  910: ORDER_CANCELED_TEXT,
};

export const LOAD_FOOD_LIST_API_KEY = 'get_buyer_food_order_list';
export const LOAD_FOOD_LIST_CLIENT_KEY = 'food_buyer';
export enum TFECardSelectionType {
  ShopeeOrder = 1,
  Topup,
  WithDrawal,
  FoodDriverOrder,
}

export enum FoodOrderBannerType {
  OrderCode = 'orderCode',
  CreateTime = 'createTime',
}

// 首屏不引入 chatbot-ui ，使用本地定义类型
export enum OrderType {
  shopee = 'shopee',
  food = 'food',
  prediction = 'prediction',
  orderWithHotQuestion = 'orderWithHotQuestion',
  foodBuyer = 'foodBuyer',
  shortcutOrder = 'shortcutOrder',
}

export enum OrderSelectorButtonType {
  Link = 1,
  Primary = 2,
}

export enum OrderSelectorQueryOrderType {
  DriverTFE = 1,
  DriverLandingPage = 2,
}

export enum FlexDirection {
  Row = 'row',
  Column = 'column',
}

export const orderDialogueType = {
  [OrderType.shopee]: DIALOGUE_TYPE.Order,
  [OrderType.food]: DIALOGUE_TYPE.FoodOrder,
  [OrderType.prediction]: DIALOGUE_TYPE.TFEOrder,
  [OrderType.orderWithHotQuestion]: DIALOGUE_TYPE.TFEOrder,
  [OrderType.foodBuyer]: DIALOGUE_TYPE.TFEFoodBuyerOrder,
  [OrderType.shortcutOrder]: DIALOGUE_TYPE.TFEOrder,
};

export const OrderTypeUsingSmallOrder = [OrderType.prediction, OrderType.shortcutOrder];

export enum OrderSendScene {
  LandingPage = 'LANDING_PAGE_ORDER_CARD',
  ShortcutOrder = 'CLICK_ORDER_SHORTCUT_ORDER',
}

export const PROBING_FORM_TRANSIFY = {
  TITLE: 'probing_form_title',
  SUBTITLE: 'probing_form_subtitle',
  PROBLEM_TYPE: 'probing_form_problem_type',
  SELECT_PROMPT: 'probing_form_select_prompt',
  ORDER: 'probing_form_order',
  SELECT_ORDER: 'probing_form_select_order',
  DESCRIPTION: 'probing_form_description',
  DESCRIPTION_PROMPT: 'probing_form_description_prompt',
  DESCRIPTION_LIMIT: 'probing_form_description_limit',
  DESCRIPTION_LIMIT_ERROR: 'probing_form_description_limit_error',
  SELECT_FILES: 'probing_form_select_files',
  FILES: 'probing_form_files',
  SUBMIT: 'probing_form_submit',
  CANNOT_FIND_ORDER: 'probing_form_cannot_find_order',
  FILE_PROMPT: 'probing_form_file_prompt',

  PREVIEW_TITLE: 'probing_form_preview_title',
  PREVIEW_VIEW_MORE: 'probing_form_preview_view_more',
  PREVIEW_FILE: 'probing_form_preview_file',

  CONFIRM_CONTENT: 'probing_form_confirm_content',
  CONFIRM_YES: 'probing_form_confirm_yes',
  CONFIRM_NO: 'probing_form_confirm_cancel',
  SUBMIT_FAILED: 'probing_form_submit_failed',
  SUBMIT_WHEN_UPLOAD: 'probing_form_submit_when_upload',
};

export const PROBING_FORM_EXP = {
  None: 'no_probing_form',
  Flow1: 'probing_form_flow1',
  Flow2: 'probing_form_flow2',
};

export const USER_TYPE_INDEX = {
  Buyer: 0,
  Seller: 1,
};

export enum OrderStyleInOrderWithHqs {
  shipping = 'shipping',
  rr = 'rr',
  order_detail = 'order_detail',
}

export enum ShortcutType {
  Intent,
  Order,
}

export const ORDER_SHORTCUT = 1;
export const NO_ORDER_SHORTCUT = 0;

export enum OrderSelectionRanking {
  NoPrediction = 'no_prediction',
  ModelA = 'model_a',
  ModelB = 'model_b',
  TopTwoOrders = 'top_2_orders',
}

export const CONTACT_COURIER_CARD = {
  TRACKING_NUMBER_COPIED: 'tracking_number_copied',
  FACEBOOK: 'facebook',
  WHATS_APP: 'whats_app',
  EMAIL: 'email',
  CALL: 'call',
  TRACK_ORDER: 'track_order',
};

// hot question 展示类型
export enum INTENT_HOT_QUESTION_DISPLAY_TYPE {
  CONTROL, // 控制组，使用旧样式
  GROUP1, // 使用 Change Questions 样式
  GROUP2, // 使用 View More 样式
}

export enum HotQuestionCategoryDisplayType {
  Old,
  New,
  OtherFrequentlyAsked, // Minimise Category UI SPCB-31864
  SmallerTab, // Minimise Category UI SPCB-31864
}

export enum NewHotQuestionDisplayType {
  Default,
  Minimise, // Minimise Category UI SPCB-31864
}

export enum LIVE_AGENT_USER_TYPE {
  NotChoose,
  Buyer,
  Seller,
}

export const CLARIFICATION_FLAG_YES = 1;

// csat card
export const VERSION_RESOLVE = 1;
export const VERSION_NO_RESOLVE = 0;
export enum DeliveryInstructionType {
  LeaveAtDoorstep = 1,
  DeliverInPerson,
  LeaveAtReception,
}

export enum ContactMethod {
  CallBeforeDelivery = 1,
  DoNotCall,
}

export const DELIVERY_INSTRUCTION_MAP = {
  [DeliveryInstructionType.LeaveAtDoorstep]: 'leave_at_doorstep',
  [DeliveryInstructionType.DeliverInPerson]: 'deliver_in_person',
  [DeliveryInstructionType.LeaveAtReception]: 'leave_at_reception',
};

export const CONTACT_METHOD_MAP = {
  [ContactMethod.CallBeforeDelivery]: 'call_before_delivery',
  [ContactMethod.DoNotCall]: 'do_not_call',
};

export const Delivery = {
  BTN_SUBMIT: 'btn_submit',
  BTN_CONFIRM_CHANGES: 'btn_confirm_changes',
  DELIVERY_INSTRUCTION: 'delivery_instruction',
  SUBMITTED_SUCCECSSFULLY: 'submitted_succecssfully',
  CHANGED_SUCCESSFULLY: 'changed_successfully',
  UNSUCESSFUL_WEBFORM_SUBMISSION: 'unsucessful_webform_submission',
  EXPEDITE_DELIVERY_TITLE: 'expedite_delivery_title',
  EXPEDITE_DELIVERY_CONTENT: 'expedite_delivery_content',
  EXPEDITE_DELIVERY_CONFIRM: 'expedite_delivery_confirm',
  EXPEDITE_DELIVERY_CANCEL: 'expedite_delivery_cancel',
};

export enum TFE_NODE_TYPE {
  CLARIFICATION_NODE = 1,
  CONDITION_NODE = 2,
  ANSWER_NODE = 3,
}

export enum MESSAGE_DOC_QA_TIP_TYPE {
  DocQAFail = 'DocQAFail',
  DocQADelay = 'DocQADelay',
  DocQAOverLength = 'DocQAOverLength',
  DocQASuccess = 'DocQASuccess',
}

export const MESSAGE_DOC_QA_TIP_TEXT = {
  [MESSAGE_DOC_QA_TIP_TYPE.DocQAFail]: 'Doc QA test group: Fail',
  [MESSAGE_DOC_QA_TIP_TYPE.DocQADelay]: 'Doc QA test group: Timeout',
  [MESSAGE_DOC_QA_TIP_TYPE.DocQAOverLength]: 'Doc QA test group: Over length',
  [MESSAGE_DOC_QA_TIP_TYPE.DocQASuccess]: 'Doc QA test group: generated by LLM',
};

export const MESSAGE_DOC_QA_TIP_TYPE_LIST = Object.keys(MESSAGE_DOC_QA_TIP_TYPE);

export enum RuleBasedMatchOptionTriggeredType {
  Default = 0,
  OrderOrTransactionType = 1,
}
